import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./mountingSturcture.css";
import Offcanvas from "react-bootstrap/Offcanvas";

export default function Navbar() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className={`navbar activeNavbar`}>
        <div className="leftNavbar">
          <Link to="/bhsmith">
          <img src="./images/Logos/Logo.svg" alt="Logo"></img>
          </Link>
          <ul className="navLinks">
            <a href="#OurSolution" style={{ textDecoration: "none" }}>
              <li>Roof Types</li>
            </a>
            <a href="#SystemService" style={{ textDecoration: "none" }}>
              <li>System Service</li>
            </a>
            <a href="#ContactUs" style={{ textDecoration: "none" }}>
              <li>Contact Us</li>
            </a>
          </ul>
        </div>
        <div className="rightNavbar">
          <Link to="/SignIn">
            <li>Sign In</li>
          </Link>
          <Link to="/SignIn">
            <button className="navButton">Get Started</button>
          </Link>
        </div>
        <div className="menuIcon">
          <Link to="/SignIn">
            <button className="navButton">Get Started</button>
          </Link>
          <i className="bi bi-list" onClick={handleShow}></i>
        </div>
      </div>

      <Offcanvas show={show} onHide={handleClose} className="navOffcanvas">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src="../images/Logos/Logo.svg" alt="log"></img>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="homeSideBar">
            <ul>
              <li>Roof Types</li>
              <li>System Service</li>
              <li>Contact Us</li>
            </ul>
            <div className="links">
              <Link to="/SignIn">
                <li>Sign In</li>
              </Link>
              <Link to="/SignIn">
                <button className="navButton">Get Started</button>
              </Link>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
